import esContent from './billing.es';

export default {
  ...esContent,
};
